/**
 * Набор эмодзи для чата портала.
 *
 * ЗАЧЕМ СВОЙ СПИСОК, А НЕ БИБЛИОТЕКА. Готовые пакеты тянут 1800+ значков со
 * спрайтами и словарём имён — это мегабайты в сборке ради поля ввода. Здесь
 * ~330 символов, которыми реально пишут в рабочем чате, разложенные по
 * понятным разделам. Значки рисует шрифт системы, картинок не грузим.
 *
 * Добавлять новые — прямо в строку нужного раздела через пробел.
 */

export type ГруппаЭмодзи = { ключ: string; значок: string; подпись: string; символы: string[] };

const строкой = (s: string) => s.trim().split(/\s+/);

export const ГРУППЫ_ЭМОДЗИ: ГруппаЭмодзи[] = [
  {
    ключ: "смайлы",
    значок: "🙂",
    подпись: "Улыбки и эмоции",
    символы: строкой(`
      😀 😃 😄 😁 😆 😅 😂 🤣 🙂 🙃 😉 😊 😇 🥰 😍 🤩 😘 😗 😚 😙
      😋 😛 😜 🤪 😝 🤗 🤭 🤫 🤔 🤐 😐 😑 😶 😏 😒 🙄 😬 😮‍💨 😔 😪
      😴 😷 🤒 🤕 🤢 🤮 🥵 🥶 😵 🤯 🥳 😎 🤓 🧐 😕 😟 🙁 😦 😧 😨
      😰 😥 😢 😭 😱 😖 😣 😞 😓 😩 😫 🥱 😤 😡 🤬 😈 💀 🤡 👻 👽
    `),
  },
  {
    ключ: "жесты",
    значок: "👍",
    подпись: "Жесты и люди",
    символы: строкой(`
      👍 👎 👌 🤌 🤏 ✌️ 🤞 🤟 🤘 🤙 👈 👉 👆 👇 ☝️ ✋ 🤚 🖐️ 🖖 👋
      🤝 🙏 ✍️ 💪 🦾 👏 🙌 👐 🤲 🫶 ✊ 👊 🤛 🤜 🖕 💅 👀 👁️ 🧠 🫀
      🙋 🙆 🙅 🤷 🤦 💁 🙇 🧑‍💻 👨‍💻 👩‍💻 👷 🕵️ 💂 🤵 👑 🎅 🦸 🦹 🧙 👶
    `),
  },
  {
    ключ: "природа",
    значок: "🌿",
    подпись: "Животные и природа",
    символы: строкой(`
      🐶 🐱 🐭 🐹 🐰 🦊 🐻 🐼 🐨 🐯 🦁 🐮 🐷 🐸 🐵 🙈 🙉 🙊 🐔 🐧
      🐦 🐤 🦆 🦅 🦉 🦇 🐺 🐗 🐴 🦄 🐝 🐛 🦋 🐌 🐞 🐜 🕷️ 🦂 🐢 🐍
      🐙 🦑 🦐 🦀 🐡 🐠 🐟 🐬 🐳 🐋 🦈 🐊 🐅 🐆 🦓 🦍 🐘 🦏 🐪 🐫
      🌵 🎄 🌲 🌳 🌴 🌱 🌿 ☘️ 🍀 🎍 🍃 🍂 🍁 🌾 🌺 🌻 🌹 🌷 🌸 💐
      🌞 🌝 🌚 🌙 ⭐ 🌟 ✨ ⚡ 🔥 💥 ☄️ 🌈 ☀️ ⛅ ☁️ 🌧️ ⛈️ ❄️ ⛄ 💧
    `),
  },
  {
    ключ: "еда",
    значок: "🍎",
    подпись: "Еда и напитки",
    символы: строкой(`
      🍏 🍎 🍐 🍊 🍋 🍌 🍉 🍇 🍓 🫐 🍈 🍒 🍑 🥭 🍍 🥥 🥝 🍅 🥑 🥦
      🥬 🥒 🌶️ 🌽 🥕 🧄 🧅 🥔 🍠 🥐 🥯 🍞 🥖 🥨 🧀 🥚 🍳 🥞 🧇 🥓
      🍔 🍟 🍕 🌭 🥪 🌮 🌯 🥗 🥘 🍝 🍜 🍲 🍛 🍣 🍱 🥟 🍤 🍙 🍚 🍥
      🍦 🍩 🍪 🎂 🍰 🧁 🥧 🍫 🍬 🍭 🍯 🍺 🍻 🥂 🍷 🥃 🍸 🍹 ☕ 🍵
    `),
  },
  {
    ключ: "дела",
    значок: "⚽",
    подпись: "Занятия и спорт",
    символы: строкой(`
      ⚽ 🏀 🏈 ⚾ 🎾 🏐 🏉 🎱 🏓 🏸 🥅 ⛳ 🏹 🎣 🥊 🥋 🎽 ⛸️ 🥌 🎿
      ⛷️ 🏂 🏋️ 🤸 ⛹️ 🤺 🤾 🏌️ 🏇 🧘 🏄 🏊 🚴 🚵 🎯 🎲 🎮 🕹️ 🎰 🧩
      🎨 🎭 🎬 🎤 🎧 🎼 🎹 🥁 🎷 🎺 🎸 🪕 🎻 ♟️ 🎳 🎪 🎟️ 🎫 🏆 🥇
    `),
  },
  {
    ключ: "места",
    значок: "🚗",
    подпись: "Транспорт и места",
    символы: строкой(`
      🚗 🚕 🚙 🚌 🚎 🏎️ 🚓 🚑 🚒 🚐 🛻 🚚 🚛 🚜 🛵 🏍️ 🚲 🛴 🛺 🚨
      ✈️ 🛫 🛬 🚀 🛸 🚁 ⛵ 🚤 🛳️ ⛴️ 🚢 🚂 🚆 🚇 🚊 🚉 🗺️ 🧭 ⛰️ 🏔️
      🌋 🏕️ 🏖️ 🏝️ 🏜️ 🏗️ 🏠 🏡 🏢 🏣 🏥 🏦 🏨 🏪 🏫 🏭 🗼 🗽 ⛲ 🌃
    `),
  },
  {
    ключ: "работа",
    значок: "📊",
    подпись: "Работа и предметы",
    символы: строкой(`
      💼 📁 📂 🗂️ 📅 📆 🗓️ 📇 📈 📉 📊 📋 📌 📍 📎 🖇️ 📏 📐 ✂️ 🗃️
      🗄️ 🗑️ 🔒 🔓 🔑 🗝️ 🔨 🪓 ⛏️ 🛠️ 🔧 🔩 ⚙️ 🧰 🧲 ⚗️ 🔬 🔭 📡 💉
      💻 🖥️ 🖨️ ⌨️ 🖱️ 💾 💿 📀 📱 ☎️ 📞 📟 📠 📺 📻 🎙️ ⏰ ⏳ 🔋 🔌
      💡 🔦 📖 📚 📓 📒 📝 ✏️ 🖊️ 🖋️ 📄 📃 📑 🧾 💰 💵 💳 🧮 📦 📬
    `),
  },
  {
    ключ: "символы",
    значок: "✅",
    подпись: "Символы",
    символы: строкой(`
      ❤️ 🧡 💛 💚 💙 💜 🖤 🤍 🤎 💔 ❣️ 💕 💞 💓 💗 💖 💘 💝 ✅ ☑️
      ✔️ ❌ ❎ ⭕ 🚫 ⛔ ‼️ ⁉️ ❓ ❔ ❗ ❕ ⚠️ 🔞 ♻️ 🔰 ⚜️ 🔱 📛 🆗
      🆕 🆙 🆒 🆓 🈶 🔴 🟠 🟡 🟢 🔵 🟣 ⚫ ⚪ 🟥 🟧 🟨 🟩 🟦 🟪 ⬛
      ➕ ➖ ➗ ✖️ 💯 🔥 ⭐ 🌟 💫 ⚡ 🎉 🎊 🎁 🏁 🚩 🔔 🔕 💤 💬 👌
    `),
  },
];

/** Что показываем в «Недавних», пока человек ничего не выбирал. */
export const ЭМОДЗИ_ПО_УМОЛЧАНИЮ = ["👍", "🔥", "😂", "❤️", "👌", "🙏", "✅", "💯"];

const КЛЮЧ_ХРАНЕНИЯ = "yuc-emoji-recent";
const СКОЛЬКО_ПОМНИМ = 24;

export function недавниеЭмодзи(): string[] {
  if (typeof window === "undefined") return ЭМОДЗИ_ПО_УМОЛЧАНИЮ;
  try {
    const сырое = window.localStorage.getItem(КЛЮЧ_ХРАНЕНИЯ);
    const список = сырое ? (JSON.parse(сырое) as unknown) : null;
    if (Array.isArray(список) && список.length) return список.filter((x) => typeof x === "string").slice(0, СКОЛЬКО_ПОМНИМ);
  } catch { /* приватный режим или мусор в хранилище — не беда */ }
  return ЭМОДЗИ_ПО_УМОЛЧАНИЮ;
}

/** Запомнить выбранный значок первым в списке недавних. */
export function запомнитьЭмодзи(символ: string): void {
  if (typeof window === "undefined") return;
  try {
    const было = недавниеЭмодзи().filter((x) => x !== символ);
    window.localStorage.setItem(КЛЮЧ_ХРАНЕНИЯ, JSON.stringify([символ, ...было].slice(0, СКОЛЬКО_ПОМНИМ)));
  } catch { /* см. выше */ }
}
